import { ConectoresComandos, ConectoresComandoCadastro, ConectoresComandoDetalhes } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/comandos',
    parent: '/conectores',
    text: 'Comandos',
    match: /\/conectores\/comandos+$/,
    sider: true,
    component: ConectoresComandos,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/comando/:id',
    text: 'Comando',
    component: ConectoresComandoCadastro,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/comando/detalhes/:idConfiguracao/:id',
    text: 'Comando',
    component: ConectoresComandoDetalhes,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
